export {default as HealthDataFooter} from './healthDataFooter';
export {default as MedicationsFooter} from './medicationsFooter';
export {default as ProfileTabFooter} from './profileTabFooter';
export {default as RoutineFooter} from './routineFooter';
export {default as SymptomFooter} from './symptomFooter';
